export default __webpack_public_path__ + "media/images/services-06-370x250-035dc2bb2c93b285d952ab8274f63bce.jpg";